export {
    BodyL,
    BodyM,
    BodyS,
    BodyXS,
    BodyXXS,
    DsplL,
    DsplM,
    DsplS,
    H1,
    H2,
    H3,
    H4,
    H5,
    TextL,
    TextM,
    TextS,
    TextXS,
} from '@sberdevices/plasma-typo';
export type { TypographyTypes } from '@sberdevices/plasma-core';

export * from './Body';
export * from './Button';
export * from './Caption';
export * from './Display';
export * from './Footnote';
export * from './Headline';
export * from './Paragraph';
export * from './Underline';
